import { useState } from 'react';

import { Spin } from 'antd';

import CuisineForm from './cuisine-form';

import TitledCard from '../../../layout-components/titled-card';

const NewCuisine: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <TitledCard title="Nowa kuchnia" backUrl="..">
        <CuisineForm setLoading={setLoading} />
      </TitledCard>
    </Spin>
  );
};
export default NewCuisine;
